import React, { FunctionComponent, useEffect, useMemo } from "react"
import {
  RegisterOptions,
  useFormContext,
  ValidationRule,
} from "react-hook-form"
import { iChangeType } from "../../definitions/interfaces"

interface iFormWrapProps {
  validation?: RegisterOptions
}

const FormWrap = <T,>(
  Component: FunctionComponent<T>,
): FunctionComponent<T & iFormWrapProps> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const C = ({ name, validation, ...rest }: any) => {
    const { setValue, getValues, errors } = useFormContext()

    const error = useMemo(() => {
      if (!errors) return null

      if (name.includes(".")) {
        const names = name.split(".")
        let val = errors
        names.forEach((n: string) => {
          if (val) val = val[n]
        })
        return val
      }
      return errors[name]
    }, [errors, name])

    const handleValue = ({ name, value }: iChangeType) => {
      setValue(name, value, { shouldDirty: true, shouldValidate: true })
    }

    return (
      <Component
        {...{
          name,
          initialValue: getValues(name),
          validation,
          onChange: handleValue,
          error,
          ...rest,
        }}
      />
    )
  }
  return C
}

export default FormWrap
